import { Box, Paper, Table, TableBody, TableContainer } from "@mui/material";
import EnhancedTableHead from "./TableHead";
import React from "react";
import TableList from "./TableList";
import { useGetProcedureTemplatesQuery } from "../../../../Service/Masters";
// export interface Data {
//   id: number;
//   sno?: number;
//   procedureTitle: string;
//   price: number;
//   gst: number;
//   activeStatus: any;
//   createdAt: string;
//   updatedAt: string;
// }

type Order = "asc" | "desc";

const DashTable = (props) => {
  const { setShow,locationData,setUpdateData,refetch } = props;
  const [order, setOrder] = React.useState<Order>("asc");
  const [orderBy, setOrderBy] = React.useState<keyof any>("createdAt");

  const handleRequestSort = (
    event: React.MouseEvent<unknown>,
    property: keyof any
  ) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  return (
    <div className="Enhance-table">
      <Box sx={{ width: "100%" }}>
        <Paper sx={{ width: "100%", mb: 2 }}>
          <TableContainer className="custom-tablebody">
            <Table sx={{ minWidth: 800 }} aria-labelledby="tableTitle">
              <EnhancedTableHead
                order={order}
                orderBy={orderBy}
                onRequestSort={handleRequestSort}
              />

              <TableBody>
                <TableList
                  setShow={setShow}
                locationData={locationData}
                  setUpdateData={setUpdateData}
                //   setView={setView}
                  refetch={refetch}
                />
              </TableBody>
            </Table>
            {/* {isLoading && (
              <div className="d-flex justify-content-center">
                <TableLoad />
              </div>
            )}
            {customer?.data?.length === 0 && (
              <div className="d-flex justify-content-center">
                <small className="m-3">No results found!</small>
              </div>
            )} */}
          </TableContainer>
        </Paper>
      </Box>
    </div>
  );
};

export default DashTable;
